<template>
  <div class="payment-tasks-list">
    <row class="payment-tasks-list__header" :gutter="16">
      <i-col class="ms-help" span="11">
        Дата получения
      </i-col>
      <i-col class="ms-help" span="11">
        Сумма
      </i-col>
      <i-col class="ms-help" span="2"> </i-col>
    </row>
    <row
      class="payment-tasks-list__row"
      :gutter="16"
      v-for="(item, index) in contract.payment_tasks"
      :key="item.id"
    >
      <i-col span="11">
        <date-picker
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          v-model="item.payment_date"
        />
      </i-col>
      <i-col span="11">
        <input-number
          :min="0"
          :max="getMax(index)"
          v-model="item.value"
          :formatter="costsFormatter"
          :parser="costsParser"
        />
      </i-col>
      <i-col span="2">
        <i-button
          class="payment-tasks-list__remove"
          shape="circle"
          icon="md-trash"
          type="text"
          @click="remove(index)"
        />
      </i-col>
    </row>
    <div class="payment-tasks-list__add">
      <i-button
        class="payment-tasks-list__button ms-link"
        type="text"
        icon="md-add"
        @click="addRow"
      >
        Добавить этап
      </i-button>
    </div>
  </div>
</template>

<script>
import { costsFormatter, costsParser } from '@/utils'

export default {
  props: ['contract'],
  methods: {
    getMax (index) {
      const { payment_tasks } = this.contract
      const otherSum = payment_tasks.reduce((prev, s, i) => {
        if (i !== index) return prev + s.value
        return prev
      }, 0)

      return this.contract.prepaid_amount - otherSum
    },
    addRow () {
      this.contract.payment_tasks.push({
        id: Date.now(),
        payment_date: null,
        value: 0
      })
    },
    remove (index) {
      if (this.contract.payment_tasks.length > 2) {
        this.contract.payment_tasks.splice(index, 1)
      } else {
        this.$set(this.contract, 'payment_tasks', [])
        this.$emit('toggle-off')
      }
    },
    costsFormatter,
    costsParser
  }
}
</script>

<style lang="less">
.payment-tasks-list {
  &__header {
    .ivu-col {
      text-align: center;
      padding: 8px 0;
    }
  }

  &__row {
    &:not(:last-child) {
      margin-bottom: 8px;
    }

    .ivu-input-number,
    .ivu-date-picker {
      width: 100%;
    }

    .ivu-col {
      text-align: center;
    }
  }

  &__button {
    &.ivu-btn-text:hover,
    &.ivu-btn-text:focus {
      background: rgba(@primary-color, 0.1);
    }
  }

  &__add {
    margin-top: 8px;
    text-align: center;
  }

  &__remove {
    color: @danger-color;

    &.ivu-btn-text:hover,
    &.ivu-btn-text:focus {
      background: rgba(@danger-color, 0.1);
      color: @danger-color;
    }
  }
}
</style>
